import { djangoClientQueryFactory } from "api/client/helpers/queryFactory";
import { paths } from "api/schema/api-schema";
import assert from "assert";

export const runGet = djangoClientQueryFactory(
  { method: "get", path: "/wes/run/{id}/" },
  {
    formatInput: (
      id: paths["/wes/run/{id}/"]["get"]["parameters"]["path"]["id"],
    ) => {
      return { params: { path: { id } } };
    },

    formatQueryKey: (p) => {
      return [p];
    },

    handleResponse: (res) => {
      const data = res.data;

      assert(
        data !== undefined,
        "Expected data to be defined when retrieving a run",
      );
      return data;
    },
  },
);
